import { AxiosInstance } from 'axios';
import { User } from './User';
import { UserTransformer } from './UserTransformer';
import { axiosProxy } from "@/plugins/axios";
import { AccountTransformer } from './AccountTransformer';
import { AbsenceTransformer } from './AbsenceTransformer';

export class UserRepository {
  private api: AxiosInstance = axiosProxy;

  async me(): Promise<User> {
    const response = await this.api.get(`/users/me?include=artist.media`);
    return new UserTransformer().toClass(response.data['data']);
  }

  async register(payload: any): Promise<any> {
    try {
      return await this.api.post('users', payload);
    } catch (error) {
      throw error;
    }
  }
  async validate(payload: any): Promise<any> {
    try {
      return await this.api.post('validate-user', payload);
    } catch (error) {
      throw error;
    }
  }




  async createAbsence(startDate: string, endDate: string) {
    try {
      const payload = {
        absent_since: startDate,
        absent_until: endDate
      };
      const res = await this.api.post('absences', payload);
      return new AbsenceTransformer().toClass(res.data['data']);
    } catch (error) {
      throw error;
    }
  }

  async removeAbsence(id: string) {
    try {
      return await this.api.delete(`absences/${id}`);
    } catch (error) {
      throw error;

    }
  }

  async account() {
    try {
      const res = await this.api.get('profile/account');
      return new AccountTransformer().toClass(res.data['data']);
    } catch (error) {
      throw error;
    }
  }

  async updateAccount(userId: string, payload) {
    try {
      return await this.api.put(`users/${userId}`, payload);
    } catch (error) {
      throw error;
    }
  }

  async evaluate() {
    try {
      return await this.api.post('profile/evaluate');
    } catch (error) {
      throw error;
    }
  }

}